import {
  useIntl,
  FormattedMessage,
  Link,
  navigate,
  IntlContextConsumer,
  changeLocale,
} from "gatsby-plugin-intl";

export { FormattedMessage, Link, navigate, IntlContextConsumer, changeLocale };

export function useT() {
  const intl = useIntl();
  const t = (
    id: string,
    values?: Parameters<typeof intl.formatMessage>[1]
  ): string => intl.formatMessage({ id }, values) as unknown as string;
  return { t, locale: intl.locale };
}
